(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4561],{

/***/ 49350:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/electric-cars",
      function () {
        return __webpack_require__(79734);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ FeatureElectricCars; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 264 modules
var shared_src = __webpack_require__(60620);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 57 modules
var ui_src = __webpack_require__(72284);
// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-benefits/ev-benefits.module.css
var ev_benefits_module = __webpack_require__(2258);
var ev_benefits_module_default = /*#__PURE__*/__webpack_require__.n(ev_benefits_module);
// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/landing-feature-electric-cars.module.css
var landing_feature_electric_cars_module = __webpack_require__(73825);
var landing_feature_electric_cars_module_default = /*#__PURE__*/__webpack_require__.n(landing_feature_electric_cars_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-benefits/ev-benefits.tsx




const BenefitCard = ({ benefit  })=>{
    const { icon , title , text  } = benefit;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (ev_benefits_module_default()).cardContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ev_benefits_module_default()).iconContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokIcon */.MW, {
                    iconName: icon,
                    size: 24
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ev_benefits_module_default()).textContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: (ev_benefits_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ev_benefits_module_default()).text,
                        children: text
                    })
                ]
            })
        ]
    });
};
const EvBenefits = ({ evBenefits  })=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (landing_feature_electric_cars_module_default()).heading,
                children: "Benefits of an electric car"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (ev_benefits_module_default()).cardList,
                children: evBenefits.map((benefit)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                        benefit: benefit
                    }, `benefit-${benefit.title}`))
            })
        ]
    });

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-benefits/index.ts


// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-charging/ev-charging.module.css
var ev_charging_module = __webpack_require__(88088);
var ev_charging_module_default = /*#__PURE__*/__webpack_require__.n(ev_charging_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-charging/ev-charging.tsx






const VideoLinksSection = ({ firstText , video , secondText , links  })=>{
    const { videoId , title: videoTitle , buttonLabel , thumbnail  } = video;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (ev_charging_module_default()).largeText,
                children: firstText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
                className: (ev_charging_module_default()).video,
                videoId: videoId,
                title: videoTitle,
                buttonLabel: buttonLabel,
                customThumbnail: (0,src/* getStoryblokImageServiceUrl */.Vb)(thumbnail.filename, {
                    filters: [
                        {
                            quality: 80
                        }
                    ]
                }),
                videoUrlOptions: {
                    autoplay: 1
                },
                showNewPlayIcon: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                className: (ev_charging_module_default()).largeText,
                children: secondText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (ev_charging_module_default()).linkList,
                children: links.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: link.url.url,
                        className: (ev_charging_module_default()).linkText,
                        children: link.text
                    }, `evLink-${index}`))
            })
        ]
    });
};
const EvCharging = ({ evCharging  })=>{
    const { title , firstText , video , secondText , links , subtitle , text  } = evCharging;
    const textContent = (0,shared_src/* renderWithResolver */.be)(text);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (landing_feature_electric_cars_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoLinksSection, {
                firstText: firstText,
                video: video[0],
                secondText: secondText,
                links: links
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (ev_charging_module_default()).subheading,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (landing_feature_electric_cars_module_default()).textContent,
                children: textContent
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-charging/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-faqs/ev-faqs.tsx




const EvFaqs = ({ title , faqs  })=>{
    const accordionItems = faqs.map((faq)=>({
            title: faq.title,
            children: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: (0,shared_src/* renderWithResolver */.be)(faq.body)
                })
        }));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "faq-section",
                className: (landing_feature_electric_cars_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Accordion */.UQ, {
                title: title,
                items: accordionItems,
                buttonId: title,
                sectionId: "ev-faq-section"
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-faqs/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-info-card/ev-info-card.module.css
var ev_info_card_module = __webpack_require__(3990);
var ev_info_card_module_default = /*#__PURE__*/__webpack_require__.n(ev_info_card_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-info-card/ev-info-card.tsx



const EvInfoCard = ({ evInfo  })=>{
    const { icon , title , text  } = evInfo[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ev_info_card_module_default()).cardContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ev_info_card_module_default()).iconTitleContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokIcon */.MW, {
                        iconName: icon,
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ev_info_card_module_default()).text,
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-info-card/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-pre-footer/ev-pre-footer.module.css
var ev_pre_footer_module = __webpack_require__(79337);
var ev_pre_footer_module_default = /*#__PURE__*/__webpack_require__.n(ev_pre_footer_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-pre-footer/ev-pre-footer.tsx




const handleClick = (url)=>{
    window.open(url, "_blank");
};
const EvPreFooter = ({ evCta , image  })=>{
    const { label , url  } = evCta[0];
    const { filename , alt  } = image;
    const sbImageUrl = (0,src/* getStoryblokImageServiceUrl */.Vb)(filename, {
        filters: [
            {
                quality: 80
            }
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ev_pre_footer_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                type: "submit",
                "data-testid": "ev-button",
                onClick: ()=>handleClick(url),
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: (ev_pre_footer_module_default()).preFooterImage,
                    src: sbImageUrl,
                    alt: alt ? alt : "pre footer image"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-pre-footer/index.ts


;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-range/ev-range.tsx



const EvRange = ({ evRange  })=>{
    const { title , text  } = evRange;
    const rangeText = (0,shared_src/* renderWithResolver */.be)(text);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (landing_feature_electric_cars_module_default()).heading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (landing_feature_electric_cars_module_default()).textContent,
                children: rangeText
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/ev-range/index.ts


// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/explore-our-evs/carousel/carousel.module.css
var carousel_module = __webpack_require__(47219);
var carousel_module_default = /*#__PURE__*/__webpack_require__.n(carousel_module);
// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/explore-our-evs/carousel/carousel.tsx






const showVehicleCardV2 = (0,environments_src/* readFromEnv */.u)(environments_src/* Env.VehicleCardV2 */.X.VehicleCardV2) === "true";
const Carousel = ({ carouselName , vehicles  })=>{
    const navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                name: carouselName,
                swiperSettings: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    breakpoints: {
                        564: {
                            slidesPerView: 1
                        },
                        768: {
                            slidesPerView: 2
                        },
                        1024: {
                            slidesPerView: 3
                        }
                    }
                },
                ariaLabel: `${carouselName}-carousel`,
                children: vehicles.map((vehicle)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: showVehicleCardV2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* VehicleCardV2 */.Ul, {
                            vehicle: vehicle
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* VehicleCard */.Ur, {
                            vehicle: vehicle,
                            id: "electric-cars-carousel",
                            isSaved: false,
                            isPending: false,
                            isAvailable: vehicle.isAvailable
                        })
                    }, vehicle.vehicleId))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* CarouselControls */.J8, {
                customClassNames: (carousel_module_default()).controlsWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselPagination */.Jj, {
                        name: carouselName,
                        className: classnames_default()(`${carouselName}-pagination`, (carousel_module_default()).pagination, (carousel_module_default()).customPagination),
                        "data-testid": "ds-carousel-pagination",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselNavigation */.Pn, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        ariaHidden: true,
                        customClassNames: {
                            prevButton: (carousel_module_default()).prevButton,
                            nextButton: (carousel_module_default()).nextButton
                        }
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/explore-our-evs/explore-our-evs.module.css
var explore_our_evs_module = __webpack_require__(56896);
var explore_our_evs_module_default = /*#__PURE__*/__webpack_require__.n(explore_our_evs_module);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/lib/hooks/use-latest-vehicles.tsx
var use_latest_vehicles = __webpack_require__(82015);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/explore-our-evs/explore-our-evs.tsx






const ExploreEvs = ()=>{
    const { data , error  } = (0,use_latest_vehicles/* useLatestVehicles */.K)({
        fuelType: "Electric",
        numberOfVehicles: 6
    });
    if (!data || error) {
        console.error(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    const handleClick = ()=>{
        window.open("https://www.cinch.co.uk/used-cars/electric-fuel-type", "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (landing_feature_electric_cars_module_default()).heading,
                children: "Explore our EVs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel, {
                carouselName: "electric-vehicles-carousel",
                vehicles: data.vehicleListings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (explore_our_evs_module_default()).buttonWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Primary */.sq, {
                    type: "submit",
                    "data-testid": "ev-button",
                    onClick: handleClick,
                    children: "Browse our electric cars"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/explore-our-evs/index.ts


// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/intro/intro.module.css
var intro_module = __webpack_require__(66236);
var intro_module_default = /*#__PURE__*/__webpack_require__.n(intro_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/intro/intro.tsx


const EvIntro = ({ introText  })=>/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (intro_module_default()).evIntroText,
            children: introText
        })
    });

// EXTERNAL MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/jargon-buster/jargon-buster.module.css
var jargon_buster_module = __webpack_require__(89401);
var jargon_buster_module_default = /*#__PURE__*/__webpack_require__.n(jargon_buster_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/jargon-buster/jargon-buster.tsx





const JargonList = ({ jargon  })=>{
    const { title , text  } = jargon;
    const textContent = (0,shared_src/* renderWithResolver */.be)(text);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (jargon_buster_module_default()).jargonList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: (jargon_buster_module_default()).subheading,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: textContent
            })
        ]
    });
};
const JargonBuster = ({ jargonContent  })=>{
    const { title , body , jargonList  } = jargonContent;
    const bodyContent = (0,shared_src/* renderWithResolver */.be)(body);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (jargon_buster_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* Wrapper */.im, {
            isSlim: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (landing_feature_electric_cars_module_default()).heading,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (jargon_buster_module_default()).subheading,
                    children: bodyContent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: jargonList.map((jargonItem)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(JargonList, {
                            jargon: jargonItem
                        }, `jargon-${jargonItem.title}`))
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/components/jargon-buster/index.ts


// EXTERNAL MODULE: ../../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(82070);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../../libs/shared/compare-cars/src/index.ts + 5 modules
var compare_cars_src = __webpack_require__(90188);
// EXTERNAL MODULE: ../../../libs/data/user/src/index.ts + 7 modules
var user_src = __webpack_require__(13649);
// EXTERNAL MODULE: ../../../libs/data/favourites/src/index.ts + 2 modules
var favourites_src = __webpack_require__(80525);
// EXTERNAL MODULE: ../../../libs/shared/auth-modal/src/index.ts + 14 modules
var auth_modal_src = __webpack_require__(10025);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/landing-feature-electric-cars.tsx





















const SharedCompareBar = dynamic_default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90188)).then((module)=>module.CompareBar), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90188)
            ]
    },
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(90188)
            ]
    },
    ssr: false
});
function FeatureElectricCars({ story , generatedAt , preview  }) {
    var ref;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const { status: userStatus  } = (0,user_src/* useUserStore */.LM)();
    const { addFavourite  } = (0,favourites_src/* useFavouritesStore */.rk)();
    const { intro , benefitsOfAnElectricCar , chargingAnElectricCar , electricCarRange , didYouKnow , electricCarsJargon , electricCarsFaqs , preFooter  } = content;
    const evChargingContent = chargingAnElectricCar[0];
    const evRangeContent = electricCarRange[0];
    const evJargonContent = electricCarsJargon[0];
    const { title: faqTitle , faqs  } = electricCarsFaqs[0];
    const { evCta , image  } = preFooter[0];
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    const contentIntroText = (0,shared_src/* renderWithResolver */.be)(intro);
    const isLoggedIn = userStatus === "valid";
    (0,react.useEffect)(()=>{
        (0,auth_modal_src/* handlePostAuthFavourite */.lG)(addFavourite, isLoggedIn);
    }, [
        addFavourite,
        isLoggedIn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(compare_cars_src.CompareBarProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "Electric cars - cinch",
                fallbackDescription: "Plug into the benefits of making your drive more electric, and choose from a wide range of electric cars to buy entirely online."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (landing_feature_electric_cars_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_electric_cars_module_default()).electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvIntro, {
                            introText: contentIntroText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_electric_cars_module_default()).electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvBenefits, {
                            evBenefits: benefitsOfAnElectricCar
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: classnames_default()((landing_feature_electric_cars_module_default()).electricCarsWrapper, (landing_feature_electric_cars_module_default()).sectionSpacer)
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreEvs, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: classnames_default()((landing_feature_electric_cars_module_default()).electricCarsWrapper, (landing_feature_electric_cars_module_default()).sectionSpacer)
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvCharging, {
                            evCharging: evChargingContent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_electric_cars_module_default()).electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvRange, {
                            evRange: evRangeContent
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_electric_cars_module_default()).electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvInfoCard, {
                            evInfo: didYouKnow
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (landing_feature_electric_cars_module_default()).electricCarsWrapper
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EvFaqs, {
                            title: faqTitle,
                            faqs: faqs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JargonBuster, {
                        jargonContent: evJargonContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EvPreFooter, {
                        evCta: evCta,
                        image: image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedCompareBar, {})
                ]
            })
        ]
    });
}
/* harmony default export */ var landing_feature_electric_cars = ((/* unused pure expression or super */ null && (FeatureElectricCars)));

// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/lib/get-static-props.ts


async function getStaticPropsfn({ preview =false  }) {
    const ddMeta = {
        traceId: (0,datadog_server_src/* getTraceId */.Wj)(),
        traceTime: Date.now()
    };
    try {
        var ref, ref1;
        const story = await (0,src/* getStoryBySlug */.OI)("electric-cars", {
            version: preview ? "draft" : "published"
        });
        if (!story) {
            throw new Error("Electric car Story not found");
        }
        const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.evHero) === null || ref1 === void 0 ? void 0 : ref1[0];
        (0,datadog_server_src/* setTag */.YA)("response.code", 200);
        return {
            props: {
                ddMeta,
                story,
                preview,
                generatedAt: Date.now(),
                layoutProps: {
                    heroProps: HeroProps,
                    showBorderRadius: true
                }
            },
            revalidate: 300
        };
    } catch (error) {
        console.error(error);
        if (typeof error === "string" || error instanceof Error) {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        return {
            notFound: true,
            props: {
                ddMeta
            },
            revalidate: 30
        };
    }
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("electric-cars.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-electric-cars/src/index.ts



;// CONCATENATED MODULE: ./pages/electric-cars/index.tsx
var __N_SSG = true;



/***/ }),

/***/ 2258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardList":"ev-benefits_cardList__VRDk3","cardContainer":"ev-benefits_cardContainer__Nun_z","iconContainer":"ev-benefits_iconContainer__0gD_P","textContainer":"ev-benefits_textContainer__iN0uc","title":"ev-benefits_title__zqOMN"};

/***/ }),

/***/ 88088:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subheading":"ev-charging_subheading__5r94K","largeText":"ev-charging_largeText__X92U4","video":"ev-charging_video__CWVCx","linkList":"ev-charging_linkList__93VyJ","linkText":"ev-charging_linkText__TYCMn"};

/***/ }),

/***/ 3990:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ev-info-card_cardContainer__VMPwg","iconTitleContainer":"ev-info-card_iconTitleContainer__arg7j","text":"ev-info-card_text__KwoSK"};

/***/ }),

/***/ 79337:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ev-pre-footer_container__F2p4N","preFooterImage":"ev-pre-footer_preFooterImage__E2CYe"};

/***/ }),

/***/ 47219:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"controlsWrapper":"carousel_controlsWrapper__NByuL","pagination":"carousel_pagination__lB57g","customPagination":"carousel_customPagination__PaGLu"};

/***/ }),

/***/ 56896:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"explore-our-evs_buttonWrapper__Zp9ZJ"};

/***/ }),

/***/ 66236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"evIntroText":"intro_evIntroText__uvwED"};

/***/ }),

/***/ 89401:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"subheading":"jargon-buster_subheading__X_F7z","jargonList":"jargon-buster_jargonList__5ra9x","container":"jargon-buster_container__Feb63"};

/***/ }),

/***/ 73825:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"landing-feature-electric-cars_root__aO6xo","electricCarsWrapper":"landing-feature-electric-cars_electricCarsWrapper__BrJ5I","heading":"landing-feature-electric-cars_heading__3DQzR","textContent":"landing-feature-electric-cars_textContent__KfEft","sectionSpacer":"landing-feature-electric-cars_sectionSpacer__s__eK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(49350); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);